import { NavLink } from "react-router-dom";
import { channels } from "@/mocks/channels";
import { toneClasses } from "@/lib/ui";

export default function ChannelSidebar() {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <div className="border-b border-background-200 px-4 py-3.5">
        <h2 className="font-heading text-base font-bold text-foreground-950">切换内容板块</h2>
        <p className="mt-1 text-xs text-foreground-500">在八个栏目之间快速跳转</p>
      </div>
      <nav className="p-2" aria-label="内容板块切换">
        {channels.map((channel) => {
          const tone = toneClasses[channel.tone];
          return (
            <NavLink
              key={channel.slug}
              to={`/pindao/${channel.slug}`}
              className={({ isActive }) =>
                `flex items-center gap-2.5 rounded-md px-3 py-2.5 transition-colors ${
                  isActive ? "bg-primary-100" : "hover:bg-background-100"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <span className={`flex h-7 w-7 items-center justify-center rounded-md ${tone.bgSoft} ${tone.textStrong}`}>
                    <i className={`${channel.icon} text-base`} />
                  </span>
                  <span className="flex min-w-0 flex-col">
                    <span
                      className={`text-sm font-medium ${
                        isActive ? "text-primary-800" : "text-foreground-900"
                      }`}
                    >
                      {channel.name}
                    </span>
                    <span className="truncate text-xs text-foreground-500">{channel.tagline}</span>
                  </span>
                </>
              )}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}